import { Reveal } from "@components/ui";

const sectors = [
  {
    num: "01",
    title: "Residential Communities",
    desc: "Piped gas supply, smart metering, billing and collection.",
  },
  {
    num: "02",
    title: "Commercial Facilities",
    desc: "Gas networks for restaurants, hotels, malls, and retail spaces.",
  },
  {
    num: "03",
    title: "Industrial Clients",
    desc: "Bulk supply and pressure-controlled systems for manufacturing and warehousing.",
  },
  {
    num: "04",
    title: "Developers & OAs",
    desc: "Design, commissioning, operation & maintenance of LPG/SNG systems.",
  },
];

export function AboutWhoWeServeSection() {
  return (
    <section className="w-full py-14 md:py-16 lg:py-20 px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-8 md:gap-10">
        <Reveal direction="up">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2">
            <div>
              <span className="text-[13px] md:text-[14px] font-semibold tracking-[0.1em] uppercase text-[#f24d2b]">
                Industries
              </span>
              <h2 className="mt-1 text-[24px] md:text-[32px] lg:text-[40px] font-semibold tracking-[-0.04em] text-[#122d63]">
                Who We Serve
              </h2>
            </div>
            <p className="text-[14px] md:text-[16px] tracking-[-0.02em] text-[#62636c] max-w-[440px]">
              From residential communities to industrial complexes — tailored gas solutions for every sector.
            </p>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {sectors.map((sector, i) => (
            <Reveal key={i} direction="up" delay={i * 50}>
              <div className="h-full rounded-2xl border border-[#e9e8e6] p-5 md:p-6 flex flex-col gap-4 hover:border-[#f24d2b]/30 hover:shadow-sm transition-all duration-300">
                <div className="w-10 h-10 rounded-full bg-[#f24d2b] flex items-center justify-center text-white text-[14px] font-semibold shrink-0">
                  {sector.num}
                </div>
                <h3 className="text-[17px] md:text-[19px] lg:text-[21px] font-semibold tracking-[-0.03em] text-[#090d2c] leading-[1.2]">
                  {sector.title}
                </h3>
                <p className="text-[13px] md:text-[15px] tracking-[-0.02em] text-[#62636c] leading-[1.5]">
                  {sector.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
